import { History } from 'history';
import { ThunkAction } from 'redux-thunk';
import { Action, Dispatch, ActionCreator } from 'redux';

import { authenticate } from '../../services/authentication';
import { setPrivacyUser } from '../../services/notification';

import { fetchPermissions } from '../permissions/actions'
import { fetchOnboarding } from '../onboarding/actions'

import { AppState } from '../index';
import { Action as FetchAction, ActionTypes } from './types';
import { UserInterface } from '../../interfaces/user';

export const defineUser =
  (user: UserInterface, token: string) =>
    (dispatch: Dispatch<any>): void => {
      dispatch({ type: ActionTypes.DEFINE_USER, user, token });
      dispatch(fetchPermissions());
      dispatch(fetchOnboarding());
    };

export const removeUser = (dispatch: Dispatch): void => {
  dispatch({ type: ActionTypes.REMOVE_USER });
};

export const authenticationAttempt: ActionCreator<ThunkAction<void, AppState, null, Action<FetchAction>>> =
  (
    username: string,
    password: string,
    history: History
  ) =>
    async (dispatch: Dispatch<any>): Promise<void> => {
      dispatch({
        type: ActionTypes.AUTHENTICATION,
      });

      try {
        const { token, user } = await authenticate(username, password);

        dispatch({
          type: ActionTypes.AUTHENTICATION_SUCCESS,
          token,
          user,
        });

        // define o token do usuário para métricas
        setPrivacyUser(user, token);

        dispatch(fetchPermissions());
        dispatch(fetchOnboarding());

        history.push('/');
      } catch (e) {
        dispatch({
          type: ActionTypes.AUTHENTICATION_ERROR,
        });
      }
    };

export const resetState: ActionCreator<ThunkAction<void, AppState, null, Action<FetchAction>>> =
  () =>
    (dispatch: Dispatch<FetchAction>): void => {
      dispatch({
        type: ActionTypes.RESET_STATE,
      });
    };
